import { Component } from '../redux/api/componentsApiSlice';

export const findComponent = (
  id: string,
  components: Component[],
): Component | undefined => {
  return components.find(com => com._id === id);
};